import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE } from "./AuthContext";
import { ShieldCheck, ArrowUpRight } from "lucide-react";

function Stat({ label, value, to, tone, testid }) {
  const body = (
    <div className="p-4 hover:bg-[var(--subtle)] transition-colors h-full" data-testid={testid}>
      <div className="overline mb-1">{label}</div>
      <div className="font-heading text-3xl" style={{ color: tone || "var(--ink)", fontWeight: 500 }}>{value}</div>
    </div>
  );
  return to ? <Link to={to} className="block">{body}</Link> : body;
}

export default function IdCheckStatsCard() {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API_BASE}/voi/stats`).then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const pct = s.total_clients ? Math.round((s.verified / s.total_clients) * 100) : 0;
  const waitingSince = s.oldest_waiting?.submitted_at
    ? Math.max(0, Math.round((Date.now() - new Date(s.oldest_waiting.submitted_at)) / 3600000)) : null;
  return (
    <div className="card p-6 mt-6" data-testid="dashboard-id-stats">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><ShieldCheck size={16} className="text-[var(--moss)]" />
          <h2 className="font-heading text-xl" style={{ fontWeight: 500 }}>ID verification</h2></div>
        <Link to="/settings/voi-audit" className="text-[12px] text-[var(--accent)] hover:underline inline-flex items-center gap-1" data-testid="dashboard-id-stats-log">
          Audit log <ArrowUpRight size={12} /></Link>
      </div>
      <div className="mb-4">
        <div className="flex justify-between text-[12px] text-[var(--ink-2)] mb-1">
          <span data-testid="dashboard-id-verified-summary">{s.verified} of {s.total_clients} clients verified</span><span>{pct}%</span>
        </div>
        <div className="h-2 rounded-full bg-[var(--subtle)] overflow-hidden">
          <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${pct}%`, background: "var(--moss)" }} />
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--border)] border border-[var(--border)] rounded-md overflow-hidden">
        <div className="bg-[var(--paper)]"><Stat label="Not verified" value={s.unverified} to="/clients?id_filter=1" testid="dashboard-id-unverified" /></div>
        <div className="bg-[var(--paper)]"><Stat label="…with open jobs" value={s.unverified_with_open_jobs} to="/clients?id_filter=1"
          tone={s.unverified_with_open_jobs ? "#B45309" : undefined} testid="dashboard-id-at-risk" /></div>
        <div className="bg-[var(--paper)]"><Stat label="Waiting for review" value={s.waiting_review}
          tone={s.waiting_review ? "var(--accent)" : undefined} testid="dashboard-id-waiting" /></div>
        <div className="bg-[var(--paper)]"><Stat label="Waiting for client" value={s.pending_client} testid="dashboard-id-pending" /></div>
      </div>
      <div className="text-[11px] text-[var(--ink-3)] mt-3" data-testid="dashboard-id-footnote">
        {s.approved_last_30d} verified in the last 30 days
        {waitingSince !== null && ` · oldest submission waiting ${waitingSince}h (media auto-deletes at 72h)`}
      </div>
    </div>
  );
}
